export function ReviewProgressBar({
  done,
  total,
}: {
  done: number;
  total: number;
}) {
  const percent = total > 0 ? (done / total) * 100 : 0;
  return (
    <div className="mt-4">
      <div className="h-2 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-emerald-500 to-emerald-400 rounded-full transition-[width] duration-500 ease-out motion-reduce:transition-none"
          style={{ width: `${percent}%` }}
        />
      </div>
      <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 text-center">
        {total > 0 ? `${Math.round(percent)}% Complete` : "No fields"}
      </p>
    </div>
  );
}
